import { render, staticRenderFns } from "./OTabs.vue?vue&type=template&id=b530cf96&scoped=true"
import script from "./OTabs.vue?vue&type=script&lang=js"
export * from "./OTabs.vue?vue&type=script&lang=js"
import style0 from "./OTabs.vue?vue&type=style&index=0&id=b530cf96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b530cf96",
  null
  
)

export default component.exports